import ButtonToggle from './button-toggle'

export const AmuiButtonToggle = ButtonToggle

export default Vue => Vue.component(ButtonToggle.name, ButtonToggle)
